{
  "aiGeneratedAnswer": "Απάντηση που δημιουργήθηκε από ΤΝ",
  "allCategories": "Όλες οι κατηγορίες",
  "appliedFiltersToCurrentSearch": "Εφαρμοσμένα φίλτρα στην τρέχουσα αναζήτηση",
  "apply": "Εφαρμογή",
  "applyFilters": "Εφαρμογή φίλτρων",
  "autocompleteOptionsFound_one": "Βρέθηκε {{count}}{{label}} επιλογή αυτόματης συμπλήρωσης.",
  "autocompleteOptionsFound_other": "Βρέθηκαν {{count}}{{label}} επιλογές αυτόματης συμπλήρωσης.",
  "autocompleteSuggestion": "Πρόταση αυτόματης συμπλήρωσης: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "Βρέθηκε {{count}} πρόταση αυτόματης συμπλήρωσης.",
  "autocompleteSuggestionsFound_other": "Βρέθηκαν {{count}} προτάσεις αυτόματης συμπλήρωσης.",
  "basedOnYourDevice": " (με βάση τη συσκευή σας)",
  "basedOnYourInternetAddress": " (με βάση τη διεύθυνση IP σας)",
  "categoriesText_one": "Η παρακάτω κατηγορία έδωσε αποτελέσματα για - <strong>{{query}}</strong>",
  "categoriesText_other": "Οι παρακάτω κατηγορίες έδωσαν αποτελέσματα για - <strong>{{query}}</strong>",
  "clearAll": "Καθάρισμα όλων",
  "clearMinAndMax": "Καθάρισμα ελάχιστου και μέγιστου",
  "clearTheRangeToSelectOptions": "Καθάρισε το εύρος για επιλογή επιλογών.",
  "clearTheSearchBar": "Καθάρισε τη γραμμή αναζήτησης",
  "conductASearch": "Διεξαγωγή αναζήτησης",
  "currentLocation": "Τρέχουσα τοποθεσία",
  "didYouMean": "Μήπως εννοούσατε <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Όταν είναι διαθέσιμα αποτελέσματα αυτόματης συμπλήρωσης, χρησιμοποιήστε τα βελάκια πάνω/κάτω για προεπισκόπηση και Enter για επιλογή.",
  "feedback": "Σχόλια",
  "invalidRange": "Άκυρο εύρος",
  "max": "Μέγ.",
  "min": "Ελάχ.",
  "navigateToTheNextResultsPage": "Μετάβαση στην επόμενη σελίδα αποτελεσμάτων",
  "navigateToThePreviousResultsPage": "Επιστροφή στην προηγούμενη σελίδα αποτελεσμάτων",
  "noAutocompleteOptionsFound": "Δεν βρέθηκε καμία επιλογή αυτόματης συμπλήρωσης.",
  "noAutocompleteSuggestionsFound": "Δεν βρέθηκε καμία πρόταση αυτόματης συμπλήρωσης.",
  "noResultsFoundIn": "Δεν βρέθηκαν αποτελέσματα στο/στη {{currentVerticalLabel}}.",
  "pagination": "Σελιδοποίηση",
  "readMoreAbout": "Διαβάστε περισσότερα για <a>{{name}}</a>",
  "recentSearch": "πρόσφατη αναζήτηση: {{query}}",
  "recentSearchesFound_one": "Βρέθηκε {{count}} πρόσφατη αναζήτηση.",
  "recentSearchesFound_other": "Βρέθηκαν {{count}} πρόσφατες αναζητήσεις.",
  "removeFilter": "Αφαίρεση φίλτρου «{{displayName}}»",
  "resultPreview": "προεπισκόπηση αποτελέσματος: {{value}}",
  "resultPreviewsFound_one": "Βρέθηκε {{count}} προεπισκόπηση αποτελέσματος.",
  "resultPreviewsFound_other": "Βρέθηκαν {{count}} προεπισκοπήσεις αποτελεσμάτων.",
  "resultsCountText_one": "{{count}} Αποτέλεσμα",
  "resultsCountText_other": "{{count}} Αποτελέσματα",
  "resultsCountWithPaginationText": "{{paginateStart}} – {{paginateEnd}} από {{resultsCount}} Αποτελέσματα",
  "searchHere": "Αναζήτησε εδώ…",
  "showLess": "Εμφάνιση λιγότερων",
  "showMore": "Εμφάνιση περισσότερων",
  "showingAllInstead": "Δείχνωνται όλα τα/{{currentVerticalLabel}} αντ’ αυτού.",
  "sources_one": "Πηγή",
  "sources_other": "Πηγές ({{count}})",
  "submitSearch": "Αναζήτηση",
  "suggestionResultsCount_one": "{{label}} – {{count}} αποτέλεσμα",
  "suggestionResultsCount_other": "{{label}} – {{count}} αποτελέσματα",
  "thankYouForYourFeedback": "Ευχαριστούμε για τα σχόλιά σας!",
  "thisAnsweredMyQuestion": "Αυτό απάντησε στην ερώτησή μου",
  "thisDidNotAnswerMyQuestion": "Αυτό δεν απάντησε στην ερώτησή μου",
  "unselectAnOptionToEnterInARange": "Αποεπιλογή μιας επιλογής για εισαγωγή σε εύρος.",
  "updateYourLocation": "Ενημέρωσε την τοποθεσία σου",
  "useCurrentLocation": "Χρήση τρέχουσας τοποθεσίας",
  "useMyLocation": "Χρήση της τοποθεσίας μου",
  "viewAll": "Δες όλα",
  "viewDetails": "Δες λεπτομέρειες"
}
